import type { HTMLAttributes, ReactNode } from "react"
import { twMerge } from "tailwind-merge"

export const MainSiteContainer = ({ ...props }: { children: ReactNode }) => (
  <div className="flex flex-col justify-start min-h-screen" {...props} />
)

export const Main = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={twMerge(
      "flex-[1_1_auto] max-w-[1250px] min-h-[calc(100vh-500px)] px-5 md:px-6 mx-auto mt-2",
      className,
    )}
    {...props}
  />
)
